import {initDetailByAPI} from '@web/actions/detail'
import makeSlice from '@web/slices/chargePoint/sliceMaker'

const slice = makeSlice({
    extraReducers: (builder) => {
        builder.addCase(initDetailByAPI.fulfilled, (state, {payload}) => {
            const {pay} = payload.data
            /** 사용한 충전포인트 금액 */
            state.amount = pay.chargePointPayAmount
            /** 충전한 금액 */
            state.recharging.amount = pay.rechargePointAmount
        })
    },
})

export default slice.reducer
